<div id="{{position}}" class="col-m-12 col-xs-12 col-l-12 col-xl-12" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null" class="app-header-background"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="section-block pt-40 pb-40 color-white global-max-width">
        <div [attr.data-aos]="textAnimation ? textAnimation : null" *ngIf="title || subTitle"
          class="app-header-headline mb-60">
          <h1 *ngIf="title" [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }"
            class="center" [ngClass]="[titleSize]">{{title}}</h1>
          <p *ngIf="subTitle" class="sub-title center" [ngStyle]="{ 'color': subTitleColor }">{{subTitle}}</p>
        </div>
        <!-- start: Logos-->
        <div fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="center center">
          <ng-container *ngFor="let item of logoImgs; let LogoIndex = index">
            <div [attr.data-aos]="imagesAnimation ? imagesAnimation : null" fxFlex [ngClass]="classLogo">
              <img [src]="item.image" [ngStyle]="{'cursor': item.logoLink?'pointer':''}"
                (click)="openLink(item.logoLink)" alt="You are in good company"
                [ngClass]="(item.grayscaleFilter === true || item.grayscaleFilter === undefined)? 'filtered':''"
                (error)="updateUrl($event)" style="max-height: 60px;">
            </div>
          </ng-container>
        </div>
        <!-- end: Logos -->
      </div>
    </header>
  </div>
</div>